
import Vue from 'vue'

import StarIcon from '~/assets/svg/star.svg?inline'

export default Vue.extend({
  name: 'RPHStarRating',
  components: { StarIcon },
  props: {
    /* Количество звезд */
    value: {
      type: Number,
      default: null,
    },
    /* Убрать выбор рейтинга */
    disabled: {
      type: Boolean,
      default: false,
    },
    /* Размер звездочки */
    size: {
      type: String,
      default: 'small',
    },
  },
  data() {
    return {
      position: 0,
      rating: [{ rate: 1 }, { rate: 2 }, { rate: 3 }, { rate: 4 }, { rate: 5 }],
    }
  },
  methods: {
    getTitleString(value: number) {
      switch (value) {
        case 1: return 'звезда'
        case 2: return 'звезды'
        case 3: return 'звезды'
        case 4: return 'звезды'
        case 5: return 'звезд'
      }
    }
  },
})
